module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLightItalic.b99427f9.ttf";